import { pick } from 'lodash';
import type { PatchGroupData, PostAndPatchGroupFields, PostGroup } from './types';

function prepareCommonRelationships(group: PostGroup | PatchGroupData): MutationBodyAttributes {
  return {
    // The organisation/customer ID is required to create a group, but not to update it:
    ...(group?.organisationId
      ? {
          customer: {
            data: {
              id: `/api/v2/customers/${group?.organisationId}`,
              type: 'Customer'
            }
          }
        }
      : {})
  };
}

function prepareCommonAttributes(
  groupFields: Partial<PostAndPatchGroupFields>
): MutationBodyAttributes {
  return {
    ...pick(groupFields, ['name', 'description', 'year', 'type'])
  };
}

export function preparePatchGroup(group: PatchGroupData): PostMutationBody {
  return {
    data: {
      type: 'Group',
      attributes: prepareCommonAttributes(group),
      relationships: prepareCommonRelationships(group)
    }
  };
}

export function preparePostGroup(group: PostGroup): PostMutationBody {
  return {
    data: {
      type: 'Group',
      attributes: prepareCommonAttributes(group),
      relationships: prepareCommonRelationships(group)
    }
  };
}
